<template>
  <with-invoice :invoice-id="invoiceId">
    <template slot="default" slot-scope="{invoice}">
      <v-layout v-if="invoice.status === 'Draft'">
        <v-flex xs6>
          <batch-attach-logs-to-invoice-form :invoice-id="invoiceId"
                                             :cases-with-log="casesWithLog"
                                             title="Add all from page to invoice">
            <template slot="button-content">
              <v-icon color="red">fa-exclamation-circle</v-icon>
            </template>
          </batch-attach-logs-to-invoice-form>
        </v-flex>
        <v-flex xs3>
          <batch-attach-logs-to-invoice-form :invoice-id="invoiceId"
                                             :cases-with-log="casesWithLogWithoutAnomalies"
                                             title="Add all without anomalies from page to invoice"/>
        </v-flex>
      </v-layout>
      <div v-else>
        <!-- empty -->
      </div>
    </template>
  </with-invoice>
</template>

<script>
  import BatchAttachLogsToInvoiceForm from "./BatchAttachLogsToInvoiceForm";
  import AttachCasesWithoutAnomaliesToInvoiceForm from "./AttachCasesWithoutAnomaliesToInvoiceForm";
  import WithInvoice from "./WithInvoice";

  export default {
    name: 'invoice-case-batch-operations',
    components: {
      BatchAttachLogsToInvoiceForm,
      AttachCasesWithoutAnomaliesToInvoiceForm,
      WithInvoice
    },
    props: {
      invoiceId: {
        type: Number,
        required: true
      },
      casesWithLog: {
        type: Array,
        required: true
      }
    },
    data() {
      return {}
    },
    computed: {
      casesWithLogWithoutAnomalies() {
        return this.casesWithLog.filter(it => {
          return it.caseAnomalies.length === 0
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/analytics/invoices/InvoiceCaseBatchOperations.vue